module.exports = "/_next/static/images/logo-zasilkovna-edfdd9bd4f07d13f4d17cedec6caec16.png";